interface Window {
    utility?: (utility) => void;
}

window.utility = (): object => {
    "use strict";
    return {
        ajax: (method, endpointUrl): Promise<string> => {
            return new Promise(function (resolve, reject) {
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState === 4) {
                        if (this.status === 200)
                            resolve(this.responseText);
                        else
                            reject();
                    }
                };
                xhttp.open(method, endpointUrl);
                xhttp.send();
            });
        }
    };
};
